export default __webpack_public_path__ + "fonts/41715add62157444369066a13e873fc5.woff2";